import React from "react";
import { IntlProvider as BaseIntlProvider } from "react-intl";
import configByStore from "config/stores";
import IsoCountries from "i18n-iso-countries";
import { useShop } from "web/core/shop/ShopContext";
import loadable from "@loadable/component";

const stores = Object.keys(configByStore).map(
  (storeKey) => configByStore[storeKey]
);

stores.forEach((store) => store.countries(IsoCountries));

let ProvidersPerLocale = {};
const Messages = ({ locale, children }) => {
  if (!ProvidersPerLocale[locale]) {
    ProvidersPerLocale[locale] = loadable.lib(() =>
      import(`.front-commerce/translations/${locale}`)
    );
  }

  const Wrapper = ProvidersPerLocale[locale];
  return <Wrapper children={children} />;
};

const IntlProvider = (props) => {
  const shop = useShop();

  return props.messages ? (
    <BaseIntlProvider locale={shop.locale} messages={props.messages}>
      {props.children}
    </BaseIntlProvider>
  ) : (
    <Messages locale={shop.locale}>
      {(messages) => (
        <BaseIntlProvider locale={shop.locale} messages={messages}>
          {props.children}
        </BaseIntlProvider>
      )}
    </Messages>
  );
};

export default IntlProvider;
